import React from "react";
import Select from "react-select";
import { Button, Toast } from "react-bootstrap";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default class Errors extends React.PureComponent {
  render() {
    const { errors, history } = this.props;

    return (
      <div>
        <ToastContainer autoClose={8000} />
      </div>
    );
  }
}
